"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarLoadingIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _SidebarLoadingIndicator = require("./SidebarLoadingIndicator.styled");
var SidebarLoadingIndicator = exports.SidebarLoadingIndicator = function SidebarLoadingIndicator(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/_react["default"].createElement(_SidebarLoadingIndicator.StyledLoadingIndicator, null, message);
};
SidebarLoadingIndicator.propTypes = {
  message: _propTypes.string.isRequired
};